export default {
  title: "Data Sources",
  subtitle: "Manage data sources for {productName}",
  noDataSources: "No data sources found",
  noDescription: "No description available",
  status: {
    active: "Active",
    inactive: "Inactive",
    error: "Error",
    unknown: "Unknown"
  },
  type: {
    postgresql: "PostgreSQL",
    mongodb: "MongoDB",
    mysql: "MySQL",
    other: "Other"
  }
} as const;
